<template>
<div>
    <div class="box-page" v-if="isShowList" key="tran1">
        <div class="page-header">
            <div class="d-flex align-items-center justify-content-center">
                <span class="page-title">รายชื่อสมาชิก</span>
                <div id="wgCalendar" class="wgCalendar-normal ml-2" data-initLabelText="ทั้งหมด"></div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-search2">
                        <i class="fa fa-search"></i>
                        <input type="text" name="search" placeholder="ค้นหาชื่อและเบอร์โทร" v-model="keyword" @keypress.enter="loadList()" class="ele-search2-input">
                    </div>
                </div>
            </div>
        </div>
        <div class="page-content">
            <div class="row pb-2">
                <div class="col-md-6 box-info-bar px-2">
                    <div class="info-bar accent-purple">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ยอดเงินรวมทั้งหมด</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value">{{ total_current_money }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100" style="overflow-x: auto;">
                <table id="tb_datalist" class="table table-hover">
                    <thead>
                        <tr>
                            <th style="width: 170px; min-width: 170px;">
                            </th>
                            <th style="width: 70px; min-width: 70px;">
                                <div class="text-btn header-text text-center" @click="toggleSort('id');">
                                    <span>ลำดับ</span>
                                    <i class="fa" :class="getClassChevron('id')"></i>
                                </div>
                            </th>
                            <th style="width: 100px; min-width: 100px;">
                                <div class="header-text text-center">
                                    <span>วันที่สมัคร</span>
                                </div>
                            </th>
                            <th style="width: 90px; min-width: 90px;">
                                <div class="header-text text-center">
                                    <span>ประเภท</span>
                                </div>
                            </th>
                            <th style="width: 140px; min-width: 140px;">
                                <div class="header-text text-center">
                                    <span>เข้าใช้งานล่าสุด</span>
                                </div>
                            </th>
                            <th style="width: 130px; min-width: 130px;">
                                <div class="header-text text-center">
                                    <span>ในนาม</span>
                                </div>
                            </th>
                            <th>
                                <div class="header-text">
                                    <span>ชื่อ</span>
                                </div>
                            </th>
                            <th style="width: 180px;">
                                <div class="header-text text-left">
                                    <span>เบอร์โทร</span>
                                    <!-- <i class="fa fa-chevron-down grey"></i> -->
                                </div>
                            </th>

                            <th>
                                <div class="text-btn header-text" @click="toggleSort('current_money');">
                                    <span>ยอดเงิน</span>
                                    <i class="fa" :class="getClassChevron('current_money')"></i>
                                </div>
                            </th>

                            <th style="width: 100px; min-width: 100px;">
                                <div class="header-text text-center">
                                    <span>สถานะ</span>
                                </div>
                            </th>

                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in listMember" :key="idx">
                            <td class="align-middle">
                                <div class="show-on-hover">
                                    <div class="btn-group">
                                        <a href="#" class="btn btn-table" @click="showDetail(item.id)">รายละเอียด</a>
                                    </div>
                                    <div class="btn-group">
                                        <a data-toggle="dropdown" href="">
                                            <img height="24" :src="'../../goobank_assets/common/img/icons/threedots.png'" />
                                        </a>
                                        <div class="dropdown-menu">
                                            <a href="#" class="dropdown-item" @click="openModalPhoneUpdate(item.id, item.telephone)">แก้ไขเบอร์โทร</a>
                                            <a href="#" class="dropdown-item" @click="showEditDoc(item)">แก้ไขรูปภาพเอกสาร</a>
                                            <a href="#" class="dropdown-item" @click="deleteMember(item.id)">ลบ</a>
                                            <a href="#" class="dropdown-item" @click="permanentDeleteMember(item.id)">ลบออกจากฐานข้อมูล</a>
                                            <a href="#" class="dropdown-item" @click="changePassword(item.id)">เปลี่ยนรหัสผ่าน</a>
                                            <a href="#" class="dropdown-item" @click="loginAsUser(item.id)">เข้าสู่ระบบในฐานะ {{item.member_name}}</a>
                                            <a href="#" class="dropdown-item" @click="gotoDetailPage(item.id)">แสดงประวัติทำรายการ</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span v-text="getRowNo(idx + 1)"></span>
                            </td>
                            <td class="text-center">
                                <span v-text="item.created_at_text"></span>
                            </td>
                            <td class="text-center">
                                <span v-text="item.member_type_text"></span>
                            </td>
                            <td class="text-center">
                                <span v-text="item.last_login_text"></span>
                            </td>
                            <td class="text-center">
                                <span v-text="item.register_as_text"></span>
                            </td>
                            <td>
                                <span v-text="item.member_name + (item.member_lastname ? ' ' + item.member_lastname : '')"></span>
                            </td>
                            <td>
                                <span v-text="item.telephone"></span>
                            </td>

                            <td>
                                <span v-text="item.current_money"></span>
                            </td>

                            <td>
                                <span class="tag-staff tag-active" v-text="getActiveText(item.is_active)"></span>
                            </td>
                            <td class="text-center">
                                <label class="el-switch-in-table">
                                    <input type="checkbox" class="checkbox staff-checkbox-active"
                                    @change="toggleStatus(item.id, item.is_active)" :checked="item.is_active">
                                    <span class="slider round"></span>
                                </label>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="listMember.length <= 2" style="display:block;height:200px"></div>
                <PaginationComponent :lastPage="lastPage" :currentPage="currentPage" ref="pagination"
                @prevPage="prevPage_Click()" @nextPage="nextPage_Click()" @changePage="changePage_Click($event)"></PaginationComponent>
            </div>
        </div>
    </div>
    <member-detail v-if="isShowDetail" ref="memberDetail" :base-url="baseUrl"
    :storagePath="storagePath"
    @hideDetail="hideMemberDetail" :read-only="true" key="tran2"></member-detail>

    <member-doc v-if="isShowDocument" ref="memberDocument" :base-url="baseUrl"
    :storagePath="storagePath"
    @hideEditDoc="hideEditDoc" :read-only="true" key="tran3"></member-doc>

    <div class="modal-group" key="tran4">
        <div id="modal_change_phone" class="modal fade">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <div class="d-flex w-100 justify-content-between">
                            <div>
                                <h4 class="modal-title">แก้ไขเบอร์โทร</h4>
                            </div>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="icon-close"></i>
                            </span>
                        </button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="ele-textbox" :class="errors.has('phoneUpdate') ? 'invalid' : ''">
                                        <input type="text" class="ele-textbox-input" name="phoneUpdate"
                                        v-validate="{ required: true, regex: /^\d{10}$/, phone_exists: true }" maxlength="10"
                                        v-model="phoneUpdate">
                                        <label for="" class="ele-textbox-label">เบอร์โทร</label>
                                        <div v-if="errors.has('phoneUpdate')" class="error-text">
                                            <span v-if="errors.firstByRule('phoneUpdate', 'phone_exists')">เบอร์โทรซ้ำ</span>
                                            <span v-else>กรอกข้อมูลให้ครบถ้วน</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <div>
                            <button type="button" class="btn btn-small btn-dismiss" data-dismiss="modal">ยกเลิก</button>
                            <button type="button" class="btn btn-small btn-ok" @click="changMemberPhoneNo">แก้ไข</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import VeeValidate, { Validator } from 'vee-validate';
    import MemberDetail from './partial/MemberDetailComponent.vue';
    import MemberDocument from './partial/MemberDocumentComponent.vue';
    import PaginationComponent from './../sub_components/PaginationComponent';

    import Loading from 'vue-loading-overlay';
    Vue.use(VeeValidate);
    Vue.use(Loading);
    export default {
        components: {
            'member-detail': MemberDetail,
            'member-doc': MemberDocument,
            PaginationComponent,
            Loading,
        },
        data: function () {
            return {
                listMember: [],
                startDate: null,
                endDate: null,
                keyword: '',
                showComponent: '',
                memberID: null,
                phoneUpdate: null,
                totalItems: 0,
                totalPage: 1,
                lastPage: 1,
                pageSize: 50,
                currentPage: 1,
                loader: null,
                total_current_money: 0,
                sortValue: ['id', 'DESC'],
            }
        },
        mounted() {
        },
        created() {
            this.buildJquery();
            this.customValidate();
            this.loadList();
            setInterval(() => {
                this.loadList();
            }, 5000);
        },
        computed: {
            isShowList() {
                return this.showComponent === '';
            },
            isShowDetail() {
                return this.showComponent === 'detail';
            },
            isShowDocument() {
                return this.showComponent === 'doc';
            }
        },
        methods: {
            prevPage_Click() {
                this.currentPage -= 1;
                this.loadList();
            },
            nextPage_Click() {
                this.currentPage += 1;
                this.loadList();
            },
            changePage_Click(pageNo) {
                this.currentPage = pageNo;
                this.loadList();
            },
            loginAsUser(userId) {
                // console.log(`${this.baseUrl}/admin/api/login-as/${userId}`)
                window.location.href = `${this.baseUrl}/admin/api/login-as/${userId}`
            },
            customValidate() {
                let timeValidate = null;
                Validator.extend('phone_exists', {
                    getMessage: field => 'phone exists.',
                    validate: async value => {
                        clearTimeout(timeValidate);
                        await new Promise(resolve => {
                            timeValidate = setTimeout(() => {
                                resolve();
                            }, 500);
                        });
                        let isExists = false;
                        if (timeValidate) {
                            isExists = await axios.post(`${this.baseUrl}/api/register/check-existing-phone`,
                                { telephone: this.phoneUpdate, id: this.memberID }
                            ).then(({ data }) => {
                                if (data && data.success === false) {
                                    return true;
                                } else {
                                    return false;
                                }
                            });
                        }
                        return !isExists;
                    }
                });
            },
            showLoading() {
                this.loader = this.$loading.show({
                    canCancel: false,
                });
            },
            hideLoading() {
                if (this.loader != null) {
                    this.loader.hide();
                }
            },
            loadList() {
                let params = {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    keyword: this.keyword,
                    pageSize: this.pageSize,
                    currentPage: this.currentPage,
                    sort: JSON.stringify(this.sortValue)
                };
                axios.post(`${this.baseUrl}/admin/api/list-member`, params).then(({ data }) => {
                    if (data != null) {
                        const rows = Array.isArray(data.data) ? data.data : [];
                        if (rows.length > 0) {
                            rows.forEach(item => {
                                item.created_at_text = moment(item.created_at).format('DD/MM/YYYY');
                                if (item.last_login) {
                                    item.last_login_text = moment(item.last_login).format('DD/MM/YYYY HH:mm');
                                }
                                if (item.member_type === 'borrower') {
                                    item.member_type_text = 'ผู้ขอกู้';
                                } else if (item.member_type === 'lender') {
                                    item.member_type_text = 'ผู้ให้กู้';
                                }
                                if (item.register_as === 'personal') {
                                    item.register_as_text = 'บุคคลธรรมดา';
                                } else if (item.register_as === 'juristic_person') {
                                    item.register_as_text = 'นิติบุคคล';
                                }
                            });
                        }
                        this.totalItems = (parseInt(data.total, 10) || 0);
                        this.lastPage = (parseInt(data.totalPage, 10) || 1);
                        this.listMember = rows;
                        this.total_current_money = data.total_current_money;

                        this.$nextTick(() => {
                            if (this.$refs.pagination && typeof this.$refs.pagination.bindListPageNo === 'function') {
                                this.$refs.pagination.bindListPageNo();
                            }
                        });
                    }
                });
            },
            choosePage(currentPage) {
                this.currentPage = currentPage;
                this.loadList();
            },
            getRowNo(index) {
                return ((this.currentPage - 1) * this.pageSize) + index;
            },
            verifyRegister(id) {
                $.confirmbox({
                    title: 'ยืนยัน',
                    msg: 'อนุมัติการสมัครใช่หรือไม่ ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/api/verify-register`, { id }).then(({ data }) => {
                            if (data != null && data.success) {
                                alertbox('บันทึกสำเร็จ');
                                this.loadList();
                            }
                        });
                    }
                });
            },
            buildJquery() {
                const vm = this;
                $(document).ready(function () {
                    $('#wgCalendar').wgCalendar({
                        startDate: new Date(),
                        submitDate: function(data, self) {
                            if (data.isAllDate) {
                                vm.startDate = null;
                                vm.endDate = null;
                            } else {
                                vm.startDate = moment(data.startDate).format('YYYY-MM-DD');
                                vm.endDate = moment(data.endDate).format('YYYY-MM-DD');
                            }
                            vm.loadList();
                        }
                    });
                });
            },
            showDetail(memberID) {
                this.showComponent = 'detail';
                const vm = this;
                this.showLoading();
                this.$nextTick(() => {
                    vm.$refs.memberDetail.showMemberDetail(memberID)
                    .catch(err => console.log('showMemberDetail', err))
                    .then(() => this.hideLoading());
                });
            },
            hideMemberDetail(isReloadList) {
                this.showComponent = '';
                if (isReloadList) {
                    this.loadList();
                }
            },
            showEditDoc(itemMember) {
                this.showComponent = 'doc';
                const vm = this;
                this.$nextTick(() => {
                    vm.$refs.memberDocument.showDocumentDetail(itemMember);
                });
            },
            hideEditDoc(isReloadList) {
                this.showComponent = '';
                if (isReloadList) {
                    this.loadList();
                }
            },
            openModalPhoneUpdate(memberID, phone) {
                this.memberID = memberID;
                this.phoneUpdate = phone;
                this.errors.clear();
                $('#modal_change_phone').modal('show');
            },
            changMemberPhoneNo() {
                this.$validator.validate('phoneUpdate')
                .then(isValid => {
                    if (!isValid) {
                        return;
                    }
                    $.confirmbox({
                        title: 'ยืนยัน',
                        msg: 'ยืนยันการแก้ไขเบอร์โทร ?',
                        confirmEvent: () => {
                            axios.post(`${this.baseUrl}/admin/api/change-member-phone`, {
                                id: this.memberID, phone: this.phoneUpdate
                            }).then(({ data }) => {
                                if (data != null && data.success) {
                                    alertbox('บันทึกสำเร็จ');
                                    this.loadList();
                                }
                            });
                            $('#modal_change_phone').modal('hide');
                        }
                    });
                });
            },
            deleteMember(memberID) {
                $.confirmbox({
                    title: 'ยืนยัน',
                    msg: 'ยืนยันการลบ ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/api/delete-member`, {
                            id: memberID
                        }).then(({ data }) => {
                            if (data != null) {
                                if (data.success) {
                                    alertbox('บันทึกสำเร็จ');
                                    this.loadList();
                                } else if (data.message) {
                                    alertbox(data.message);
                                }
                            }
                        });
                    }
                });
            },
            permanentDeleteMember(memberID) {
                $.confirmbox({
                    title: 'ยืนยัน',
                    msg: 'ยืนยันการลบสมาชิกออกจากฐานข้อมูล ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/api/permanent-delete-member`, {
                            id: memberID
                        }).then(({ data }) => {
                            if (data != null) {
                                if (data.success) {
                                    alertbox('บันทึกสำเร็จ');
                                    this.loadList();
                                } else if (data.message) {
                                    alertbox(data.message);
                                }
                            }
                        });
                    }
                });
            },
            changePassword(memberID) {
                $.confirmbox({
                    title: 'ยืนยันเปลี่ยนรหัส',
                    msg: 'รหัสจะส่ง SMS ไปที่เบอร์โทรศัพท์ของผู้ใช้ ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/api/change-password-member`, {
                            id: memberID
                        }).then(({ data }) => {
                            if (data != null) {
                                if (data.success) {
                                    alertbox('บันทึกสำเร็จ');
                                    this.loadList();
                                } else if (data.message) {
                                    alertbox(data.message);
                                }
                            }
                        });
                    }
                });
            },
            toggleStatus(memberID, status) {
                axios.post(`${this.baseUrl}/admin/api/toggle-member-status`, {
                    id: memberID, status: !status
                }).then(({ data }) => {
                    if (data != null) {
                        if (data.success) {
                            alertbox('บันทึกสำเร็จ');
                            this.loadList();
                        } else if (data.message) {
                            alertbox(data.message);
                        }
                    }
                });
            },
            getActiveText(status) {
                return status == null ? 'ยังไม่ยืนยัน' : (status === 1 ? 'ผ่าน' : 'ไม่ผ่าน');
            },
            toggleSort(sort) {
                let asc = this.sortValue[1];
                if (sort == this.sortValue[0]) {
                    if (asc.toLowerCase() == 'desc') {
                        asc = 'asc'
                    } else {
                        asc = 'desc'
                    }
                } else {
                    asc = 'desc'
                }
                this.sortValue = [sort, asc];
                this.loadList();
            },
            getClassChevron(columnName) {
                let result = 'fa-chevron-down';
                if (columnName == this.sortValue[0]) {
                    if (this.sortValue[1].toLowerCase() == 'desc') {
                        result = 'fa-chevron-up';
                    }
                    result += ' active';
                }
                return result;
            },
            gotoDetailPage(id) {
                location.href = this.baseUrl + '/admin/member/detail/' + id;
            },
        },
        props: {
            baseUrl: '',
            storagePath: '',
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    #v_app {
        height: 100%;
    }
    .ele-search {
        margin-left: auto;
        margin-right: 0;
        width: 400px;
        max-width: 400px;
    }
    .img-avatar {
        width: 24px;
        height: 24px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .tag-active {
        width: 90px;
        display: inline-block;
        min-width: initial;
    }
    .error-text {
        font-size: 14px;
        color: $main-color-red
    }
</style>




